import { HeritierType, IndividualPersonType } from "../../types/commonTypes/individualType";

// personne physique
export const initialIndividualState: IndividualPersonType = {
    civility: "Monsieur",
    firstName: "",
    lastName: "",
    postalCode: "",
    city: "",
    address: "",
    additionalAddress: "",
    registrationOffice: "",
    cities: []
}

export const heritierIndividualState: HeritierType = {
    quality:"",
    civility: "Monsieur",
    firstName: "",
    lastName: "",
    birthName: "",
    postalCode: "",
    city: "",
    address: "",
    additionalAddress: "",
    registrationOffice: "",
    cities: [],
    profession: "",
}